module.exports = __webpack_public_path__ + "img/money-bill-wave.3f5c9261.svg";